import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useMemo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
const flatPagerHeight = 2;
const variationStyles = {
    dark: {
        selectedColor: theme.colors.gray700,
        unselectedColor: theme.colors.gray500,
    },
    light: {
        selectedColor: theme.colors.gray100,
        unselectedColor: theme.colors.gray300,
    },
};
const FlatPager = ({ isSelected, modifier, }) => {
    const FlatPagerStyles = useMemo(() => (css `
        ${styleUtils.buttonReset}
        height: ${styleUtils.rem(flatPagerHeight)};
        width: 100%;
        ${styleUtils.transition('background')}
        background-color: ${variationStyles[modifier].unselectedColor};
        ${isSelected && css `
          background-color: ${variationStyles[modifier].selectedColor};
        `}
      `), [
        isSelected,
        modifier,
    ]);
    return (_jsx("div", { css: FlatPagerStyles }));
};
const MemoizedFlatPager = memo(FlatPager);
export { MemoizedFlatPager as FlatPager };
